import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from 'src/components/shared/dialog/Dialog';
import { ImageGameSettings } from '../../shared/ImageGameSettings';
import { ImageAppSettings } from './ImageAppSettings';

export const SettingsListHintDialog: React.FC = () => {
  const { t } = useTranslation('settings');
  return (
    <Dialog hasHeader={true}>
      <div
        className={css`
          color: #938666;
          text-align: center;
          h1 {
            color: #4d3906;
            font-size: 20px;
            text-align: center;
          }
          p {
            margin: 0 0 16px;
          }
          p:first-child {
            margin: 24px 0 16px;
          }
          section {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 12px 0;
          }
          section:last-child {
            padding-bottom: 40px;
          }
          .image-game-setting {
            margin: 20px 0 32px;
          }
          .image-app-setting {
            margin: 32px 0 40px;
          }

          /* less than iPhone6/7/8 display size */
          @media screen and (max-width: 374px) {
            font-size: 14px;
            h1 {
              font-size: 18px;
            }
            .image-app-setting {
              margin: 12px 0 40px;
            }
          }
        `}
      >
        <h1>{t('help')}</h1>
        <section>
          <p>{t('help_desc_01')}</p>
          <div className="image-game-setting">
            <ImageGameSettings />
          </div>
          <p>{t('help_desc_02')}</p>
          <div className="image-app-setting">
            <ImageAppSettings />
          </div>
          <p>{t('help_desc_03')}</p>
        </section>
      </div>
    </Dialog>
  );
};
